export const JOIN_ERROR_SUBHEADER =
  'Please reach out to the person who invited you to resolve this issue.';

export const SECURE_YOUR_PLACE_TEXT_RESERVATION =
  'Secure your place at the table and receive updates about this reservation.';

export const SECURE_YOUR_PLACE_TEXT_WAITLIST =
  'Secure your place at the table and receive updates about your place in line.';

export const MODIFY_GUESTS_SUBHEADER = `The number of invited guests exceeds the size of your party. Remove any guests who will no longer be joining.`;

export const JOIN_URL_BASE_PATH = `make-a-reservation`;
